/**
 * Makes a resulting merge of a bunch of objects, but allows a filter function to be passed in to filter
 * the resulting merges. This allows for scenarios where you want to merge "everything except that one thing"
 * or "properties that start with data-". Note that this will shallow merge; it will not create new cloned
 * values for target members.
 *
 * @public
 * @param isAllowed - Callback to determine if the given propName is allowed in the result.
 * @param target - Target object to merge following object arguments into.
 * @param args - One or more objects that will be mixed into the target in the order they are provided.
 * @returns Resulting merged target.
 */
export function filteredAssign(
    isAllowed: (propName: string) => boolean,
    inputTarget: any,
    ...args: any[]
) {
    const target = inputTarget || {};

    for (const sourceObject of args) {
        if (sourceObject) {
            for (const propName of Object.keys(sourceObject)) {
                if ((sourceObject.hasOwnProperty(propName) && !isAllowed) || isAllowed(propName)) {
                    target[propName] = sourceObject[propName];
                }
            }
        }
    }

    return target;
}
